import BaseService from '@/core/source/BaseClassicService';
import { HttpClient } from '@/core/source/httpClient';
import { ErrorHandler } from '@/core/source/apiService';
export default class FileService extends BaseService {

    initializeHttpClient() {
        const headers = {
            'Authorization': `Bearer ${localStorage.token}`,
            'content-type': 'application/octet-stream'
        };
        this.httpClient = new HttpClient(this.baseUrl + 'file_upload', headers);
    }

    uploadFile(file, params = {}) {

        const processedParams = this.paramsProcessor.prepareParams(params);
        const response = this.httpClient.post(
            `${this.apiUrl}:upload`,
            file,
            processedParams
        );
        return ErrorHandler.checkException(response);
    }
}